// The keys of Q it is Partial of E
// Q = Partial<E>
// Select entities from state (object) where Entity satisfy the Query
export default function <E = object, Q = object>(state: Record<number, E>, queries: Q): E[] {
  if (!Object.entries(state).length) {
    return [];
  }

  const whereParams = Object.keys(queries as object);

  return Object.values(state).filter((entity) => {
    let coincidences = 0;

    whereParams.forEach((key) => {
      const queryValue = queries[key as keyof Q];
      // Types issue - the keys of E includes keys of Q
      const entityValue = (entity as any)[key];

      if (queryValue === entityValue) {
        ++coincidences;
      }
    });

    return coincidences === whereParams.length;
  });
}
